import styled from "styled-components"
import { Dialog } from "@mui/material"

const RailManagementWrapper = styled.div`
  display: flex;
  flex-direction: column;

  .header-bar {
    display: flex;
    width: 100%;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 8px;

    .title {
      margin: 0;
      font-size: 20px;
      font-weight: 800;
      color: var(--cms-text-primary);
      letter-spacing: -0.01em;
    }

    .create-btn {
      border-radius: 10px;
      text-transform: none;
      font-weight: 700;
      min-height: 40px;
      padding: 8px 14px;
      box-shadow: 0 12px 24px rgba(37, 99, 235, 0.24);
    }
  }

  .rails {
    padding: 6px 0 0;
    width: 100%;
    max-width: 100%;
    margin: 0;

    .rail-section {
      display: flex;
      flex-direction: row;
      cursor: move;
      font-size: 14px;
      background: var(--cms-surface-secondary);
      border: 1px solid var(--cms-border);
      box-shadow: 0 12px 24px rgba(15, 23, 42, 0.06);
      border-radius: 12px;
      padding: 14px;
      color: var(--cms-text-primary);
      margin-bottom: 10px;

      .thumb {
        display: flex;
        width: 200px;
        align-items: center;
        margin-right: 10px;
        img {
          width: 100%;
        }
      }
      .content {
        width: calc(100% - 150px);
        display: flex;
        flex-direction: row;
        font-size: 13px;
        .heading {
          width: 100%;
          background: var(--cms-surface-muted);
          color: var(--cms-text-primary);
          padding: 4px 10px;
          border-radius: 6px;
          font-weight: 700;
        }
        .info-section {
          width: 100%;
          padding: 0px 5px;
          margin-bottom: 5px;
          .label {
            margin-right: 5px;
            display: inline-block;
            background: #edf4ff;
            color: #1e40af;
            padding: 3px 10px;
            min-width: 70px;
            border-radius: 999px;
            font-weight: 700;
          }
        }
        .info-1 {
          width: 45%;
        }
        .info-2 {
          width: 30%;
          padding-right: 30px;
        }
        .info-3 {
          width: 25%;
          .category-section {
            .category-item {
              display: inline-block;
              border: 1px solid var(--cms-border);
              border-radius: 999px;
              background: #edf4ff;
              padding: 3px 6px;
              margin-top: 5px;
              margin-right: 5px;
              color: #1e40af;
              font-weight: 700;
            }
          }
        }
      }
      .actions {
        min-width: 140px;
        display: flex;
        align-items: flex-start;
        justify-content: flex-end;
        margin-top: -6px;
      }
    }

    .empty-state {
      border: 1px dashed var(--cms-border);
      border-radius: 12px;
      background: var(--cms-surface-muted);
      padding: 26px 16px;
      text-align: center;
      color: var(--cms-text-secondary);
      font-weight: 600;
    }
  }
`

const StyledRailDialog = styled(Dialog)`
  display: flex;
  flex-direction: column;
  .MuiPaper-root {
    width: min(860px, calc(100vw - 28px));
    max-width: none;
    border-radius: 18px;
    border: 1px solid var(--cms-border);
    background: var(--cms-dialog-bg);
    box-shadow: 0 24px 48px rgba(15, 23, 42, 0.2);
  }

  .MuiDialogTitle-root {
    padding: 18px 22px 8px;
  }

  .dialog-title-group {
    display: flex;
    flex-direction: column;
    gap: 5px;
  }

  .dialog-title {
    margin: 0;
    font-size: 20px;
    font-weight: 800;
    color: var(--cms-text-primary);
    letter-spacing: -0.01em;
  }

  .dialog-subtitle {
    margin: 0;
    font-size: 13px;
    color: var(--cms-text-secondary);
    font-weight: 500;
  }

  .MuiDialogContent-root {
    padding: 10px 22px 10px;
  }

  .MuiDialogActions-root {
    padding: 8px 22px 18px;
    gap: 10px;
  }

  .dialog-cancel-btn,
  .dialog-submit-btn {
    text-transform: none;
    border-radius: 10px;
    min-height: 40px;
    font-weight: 700;
    padding: 8px 14px;
  }

  .dialog-submit-btn {
    box-shadow: 0 12px 24px rgba(37, 99, 235, 0.24);
  }

  .error {
    font-size: 0.75rem;
    color: #d32f2f;
    margin-top: 3px;
  }

  .title-bar {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    min-height: 30px;
  }
  .label-text {
    font-weight: 700;
    font-size: 13px;
    line-height: 1.4375em;
    color: var(--cms-text-primary);
  }

  .category-section {
    margin: 20px 0;

    .category-list {
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      .category-item {
        font-size: 12px;
        background: #edf4ff;
        color: #1e40af;
        padding: 6px 10px;
        margin-right: 10px;
        margin-bottom: 10px;
        border-radius: 999px;
        border: 1px solid var(--cms-border);
        font-weight: 700;
      }
    }
  }

  .resource-section {
    .resource-list {
      margin-top: 20px;
      .resource-item {
        border-radius: 4px;
        overflow: hidden;
        background: var(--cms-surface-muted);
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        width: calc(100% - 2px);
        margin-bottom: 8px;
        margin-top: 2px;
        box-shadow: 0 10px 22px rgba(15, 23, 42, 0.08);
        img {
          width: 110px;
        }
        .content {
          width: 90%;
          padding: 5px 10px;

          .resource-name {
            font-weight: 400;
            font-size: 13px;
          }
        }
      }
    }
  }
`

export { RailManagementWrapper, StyledRailDialog }
